import { render, staticRenderFns } from "./ResubmitPollForm.vue?vue&type=template&id=7fbcb481&scoped=true&"
import script from "./ResubmitPollForm.vue?vue&type=script&lang=js&"
export * from "./ResubmitPollForm.vue?vue&type=script&lang=js&"
import style0 from "./ResubmitPollForm.vue?vue&type=style&index=0&id=7fbcb481&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbcb481",
  null
  
)

export default component.exports